import React, { lazy } from 'react';
import { CheckIcon, CreditCardIcon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const productImage = 'https://cdn.magicpatterns.com/uploads/jMJpMNFgpjc5spsvfj7eWq/Diseno-sin-titulo-2026-07-14T185739.151.webp';
const items = ['6 Volumi integrali (Manuali PDF HD)', '5 Bonus strategici inclusi', '300+ Sessioni pronte all’uso', '120+ Drill e giochi professionali', 'Tutte le fasce d’età', 'Accesso a vita'];
export function PricingSection() {
  return <section id="pricing" className="bg-[#f4f8f5] px-5 py-20" data-id="element-137">
      <div className="mx-auto max-w-xl text-center" data-id="element-138">
        <p className="inline-block bg-[#09281d] px-4 py-2 text-xs font-bold uppercase tracking-widest text-white" data-id="element-139">
          Offerta a tempo limitato
        </p>
        <h2 className="mt-5 font-display text-4xl font-bold uppercase leading-none text-[#09281d] sm:text-5xl" data-id="element-140">
          Tutto incluso,{' '}
          <span className="text-emerald-700" data-id="element-141">un unico prezzo.</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-slate-600" data-id="element-142">
          Niente abbonamenti. Niente sorprese.
        </p>
        <article className="mt-10 overflow-hidden border border-emerald-950/10 bg-white text-center shadow-xl" data-id="element-143">
          <header className="border-t-4 border-emerald-500 bg-[#09281d] px-6 py-7" data-id="element-144">
            <h3 className="font-display text-3xl font-bold uppercase text-white" data-id="element-145">
              PALLAVOLO PRONTA — Pacchetto Completo
            </h3>
            <p className="mt-2 text-sm font-semibold text-emerald-300" data-id="element-146">
              6 Volumi + 5 Bonus Strategici
            </p>
          </header>
          <div className="p-7 sm:p-10" data-id="element-147">
            <img src={productImage} alt="PALLAVOLO PRONTA, pacchetto completo per allenatori di pallavolo" width={1080} height={720} loading="lazy" className="mx-auto -mt-3 mb-3 w-full max-w-md object-contain" data-id="element-148" />
            <div id="offer-details" className="mb-8 scroll-mt-3 border-y border-emerald-950/10 py-7" data-id="element-149">
              <p className="mb-5 text-xs font-bold uppercase tracking-widest text-[#09281d]" data-id="element-150">
                Cosa include il pacchetto
              </p>
              <ul className="grid gap-3 text-left sm:grid-cols-2" data-id="element-151">
                {items.map(item => <li key={item} className="flex items-center gap-2 text-sm font-semibold text-[#09281d]" data-id="element-152">
                    <span className="grid h-5 w-5 place-items-center rounded-full bg-emerald-100" data-id="element-153">
                      <CheckIcon className="h-3.5 w-3.5 text-emerald-700" data-id="element-154" />
                    </span>
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="mt-7" data-id="element-155">
              <p className="text-sm font-semibold text-slate-600" data-id="element-156">
                Valore totale: <s data-id="element-157">377€</s>
              </p>
              <div className="mt-1 flex items-baseline justify-center text-[#09281d]" data-id="element-158">
                <strong className="font-display text-8xl font-bold leading-none tracking-tight" data-id="element-159">
                  19€
                </strong>
              </div>
              <p className="mt-2 text-sm font-semibold text-slate-600" data-id="element-160">
                Prezzo originale: <s data-id="element-161">47€</s>
              </p>
              <div className="mt-3 flex flex-wrap justify-center gap-3" data-id="element-162">
                <span className="bg-emerald-500 px-3 py-1.5 text-xs font-bold uppercase tracking-widest text-white" data-id="element-163">
                  Risparmi 28€
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-164">
                  Pagamento unico
                </span>
                <span className="py-1.5 text-xs font-bold uppercase tracking-widest text-slate-600" data-id="element-165">
                  Accesso a vita
                </span>
              </div>
            </div>
            <a href="https://pallavolo-pronta.impultienda.ar/checkout" className="cta-button -mx-2 mt-6 block w-[calc(100%+1rem)] rounded-2xl px-6 py-6 text-xl font-bold sm:text-2xl" data-id="element-166">
              OTTIENI PALLAVOLO PRONTA ORA
            </a>
            <p className="mt-5 flex items-center justify-center gap-1.5 text-xs font-semibold text-slate-600" data-id="element-167">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-700" data-id="element-168" /> Protetti
              dalla nostra garanzia di rimborso di 7 giorni
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 border-t border-emerald-950/10 pt-6 text-xs font-bold text-slate-600" data-id="element-169">
              <span className="flex gap-1" data-id="element-170">
                <LockKeyholeIcon className="h-4 w-4" data-id="element-171" /> Pagamento sicuro
              </span>
              <span className="flex gap-1" data-id="element-172">
                <ZapIcon className="h-4 w-4" data-id="element-173" /> Accesso immediato
              </span>
              <span className="flex gap-1" data-id="element-174">
                <CreditCardIcon className="h-4 w-4" data-id="element-175" /> Carta · Google Pay ·
                Apple Pay
              </span>
            </div>
          </div>
        </article>
      </div>
    </section>;
}